import React from 'react'
import {FormControlLabel, FormGroup, Switch} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import {LocalizationProvider, TimePicker} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import {useAppDispatch, useAppSelector} from '../../redux'
import {saveSettings} from '../../redux/slices/settings'
import './index.scss'

const generateTime = (time: string) => {
    const [s_h, s_m] = time.split(':').map(Number)
    const start = moment()
    start.set('hour', s_h)
    start.set('minute', s_m)
    return start
}

export default function Notifications() {
    const dispatch = useAppDispatch()
    const {notification_settings, notifications_config} = useAppSelector(state => state.settings)
    const [open, setOpen] = React.useState(false)

    const toggleOpen = () => setOpen(prev => !prev)

    const onChangeValue = async (k: string, e: any) => {
        const is_time = k === 'start' || k === 'end'
        const key = is_time ? 'time' : 'live'
        // @ts-ignore
        const value = is_time ? e?.format('HH:mm') : !notification_settings.live[k]

        dispatch(saveSettings({
            ...notification_settings,
            [key]: {
                ...notification_settings[key],
                [k]: value
            }
        }))
    }
    const getValue = (k: string) => {
        // @ts-ignore
        return ['start', 'end'].indexOf(k) > -1 ? generateTime(notification_settings.time[k]) : notification_settings.live[k]
    }
    const accepted = (!!window.Notification && notifications_config.enabled)
    if (!accepted) {
        return null
    }

    return (
        <div className="mt-auto mb-auto card-shadow">
            <div className="notifications-wrapper bg-white pt-1.5 pb-6 px-6 w-full relative h-full" style={{borderRadius: '6px', border: '1px solid rgba(0, 0, 0, 0.12)'}}>
                <div
                    className="text-orange-400 font-bold text-center border-b border-orange-400 p-2.5">
                    Notifications control center
                </div>
                <div className="flex flex-row gap-2.5 flex-wrap">
                    <div className="flex flex-1 flex-col min-w-52">
                        <p className="pb-3 pt-1 text-md font-bold">Settings by status</p>
                        <FormGroup>
                            <FormControlLabel control={<Switch checked={getValue('pending')}
                                                               onChange={(e) => onChangeValue('pending', e)}/>}
                                              label='Pending Live Tips'/>
                            <FormControlLabel
                                control={<Switch checked={getValue('win')} onChange={(e) => onChangeValue('win', e)}/>}
                                label='Win Live Tips'/>
                            <FormControlLabel
                                control={<Switch checked={getValue('lost')}
                                                 onChange={(e) => onChangeValue('lost', e)}/>}
                                label='Lost Live Tips'/>
                        </FormGroup>
                    </div>
                    <div className="min-w-52 flex flex-1 flex-col">
                        <p className="pb-3 pt-1 text-md font-bold">Time interval</p>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <div className="flex flex-col gap-2.5">
                                <TimePicker label='Start time' value={getValue('start')}
                                            onChange={e => onChangeValue('start', e)}/>
                                <TimePicker label='End time' value={getValue('end')}
                                            onChange={e => onChangeValue('end', e)}/>
                            </div>

                        </LocalizationProvider>
                    </div>

                </div>
                {/*<Button variant='outlined' onClick={saveChanges} style={{width: '100%', marginTop: '20px'}}>Save changes</Button>*/}
            </div>
        </div>

    )
}